import { forwardRef, type ReactNode, type TextareaHTMLAttributes } from "react";
import { cx } from "./cx";
import { Field, type FieldSize } from "./Field";
import "./Textarea.css";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  size?: FieldSize;
  /** Use the mono font (templates, JSON). */
  mono?: boolean;
  fieldClassName?: string;
}

/** Multi-line text input with the same label/hint/error wiring as Input. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  {
    label,
    hint,
    error,
    size = "md",
    mono = false,
    id,
    required,
    disabled,
    rows = 4,
    className,
    fieldClassName,
    ...rest
  },
  ref,
) {
  return (
    <Field
      label={label}
      hint={hint}
      error={error}
      id={id}
      required={required}
      disabled={disabled}
      className={fieldClassName}
    >
      {({ controlId, describedBy }) => (
        <textarea
          ref={ref}
          id={controlId}
          rows={rows}
          className={cx(
            "ui-control",
            `ui-control--${size}`,
            "ui-textarea",
            mono && "ui-textarea--mono",
            className,
          )}
          required={required}
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        />
      )}
    </Field>
  );
});
